<template>
    <div class="pdfpage portrait pdfqksm">
        <detail :T13="exprList['T13']" v-if="isData"></detail>
        <div id="isData" style="height: 0px; line-height: 0px;">{{isFinish}}</div>
    </div>

</template>

<script>
    import detail from "@/views/dafeng/zcgkDetail.vue";
    import { getDivList } from "@/api/index.js";
    import { getZoneTableProfile, getBdata } from "@/api/zone.js";
    export default {
        name: "zcgk",
        components: {
            detail,
        },
        data() {
            return {
                divname: "",
                tableTitle: [],
                qksm: {},
                exprList: {},
                tables: [],
                isData: false,
                isPdf: true,
                //2020年数据
                moreDetails: [],
                dataJson: "",
                subjectCofig: "",
                threeLines: "",
                bdata: {},
                clearTimeSet: null,
                dialogVisible: false,
                isFinish: false,
            };
        },
        async mounted() {
            this.$cookies.set("district", "江苏", '0');
            await this.getDivData();
        },
        updated() {
            this.$nextTick(function () {
                if (this.isData) {
                    this.isFinish = true
                }
            });
        },

        methods: {
            async getDivData() {
                let res = await getDivList({ id: this.$route.query.divid });
                if (res.status == 0) {
                    this.$store.commit('changeDivData', res)
                    this.moreDetails = res;
                    this.divname = res.divname;
                    this.qksm = res.qksm;
                    this.tables = res.tables;
                    let resBdata = await getBdata();
                    if (resBdata.status == 0) {
                        this.bdata = resBdata.bdata;
                        resBdata.bdata.forEach((e) => {
                            this.exprList[e.name] = this.preview(e.expr).result;
                        });
                        //配置
                        let resProfile = await getZoneTableProfile();
                        if (resProfile.status == 0) {
                            let yop = "var bodyshow=true;"
                            let hop = eval(yop + resProfile.profile)
                            this.dataJson = hop.dataJson;
                            this.subjectCofig = hop.subjectCofig;
                            this.threeLines = hop.threeLines;
                            this.$store.commit("storageHop", hop);
                            this.tableTitle = hop.threeLines;
                            this.tableTitle.forEach((ele) => {
                                ele.title = ele.title.slice(ele.title.indexOf(".") + 1, ele.title.length);
                            });
                            this.isData = true;
                        }
                    }
                }
            },
            preview(expr) {
                try {
                    let result = eval(this.makeEnvCode(this.tables) + expr);
                    return {
                        result,
                    };
                } catch (ex) {
                    return {
                        ex,
                    };
                }
            },
        },
    };
</script>
<style>
    .left16 {
        padding-left: 1.6rem !important;
    }

    @page {
        size: a4;
        margin: 2cm -6cm 2cm 3cm;
    }

    @page rotated {
        size: landscape;
    }
    /*横置*/
    .landscape {
        page: rotated;
        width: 100%;
        height: 25cm;
    }
    /*竖表*/
    .portrait {
        width: calc(100% - 9cm) !important;
    }

    .pdfpage .hide_pdf {
        display: none;
    }

    .pdfpage {
        page-break-after: always;
    }

        .pdfpage .pageTitle {
            margin-top: 25vh;
            font-family: SimSun;
            font-weight: bold;
            /* font-size: 40px !important; */
            line-height: 2em;
            text-align: center;
            width: 100%;
            display: block;
        }

        .pdfpage h3 {
            font-size: 21px !important;
            text-align: center;
            width: 100%;
        }

        .pdfpage .echart {
            page-break-inside: avoid;
            margin: 0 auto;
            height: 400px;
            width: 14cm !important;
            border: 1px red solid;
            padding:10px;
        }

        .pdfpage p,
        .pdfpage h4,
        .pdfpage b {
            font-size: 21px !important;
            font-family: FangSong !important;
            line-height: 2em !important;
        }

        .pdfpage h4,
        .pdfpage b {
            font-family: SimHei !important;
        }

        .pdfpage p {
            text-align: justify;
        }

    .pdfqksm {
        height: auto !important;
    }

        .pdfqksm p,
        .pdfqksm h4 {
            text-indent: 2em;
        }

    .pdfpage table {
        margin: 0 auto;
        width: 100%;
        /*border: 1px solid #808080;*/
        border-spacing: 0;
        border-collapse: collapse;
        font-size: 18px;
        font-family: FangSong;
    }

        .pdfpage table thead {
            display: table-row-group;
        }

        .pdfpage table tr {
            page-break-before: always;
            page-break-after: always;
            page-break-inside: avoid;
        }

            .pdfpage table tr th,
            .pdfpage table tr td {
                border: 1px solid #808080;
                color: #000;
            }

            .pdfpage table tr th {
                height: 18px !important;
                line-height: 16px !important;
                font-size: 13px !important;
                font-weight: bold;
            }

            .pdfpage table tr td {
                font-size: 13px !important;
                line-height: 16px !important;
                height: 18px !important;
            }

            .pdfpage table tr .showright {
                font-size: 12px !important;
            }

            .pdfpage table tr .headerTitle {
                font-size: 18px !important;
            }

    .pdfpage .tableTips p {
        font-size: 13px !important;
        line-height: 14px !important;
    }

        .pdfpage .tableTips p .left16 {
            padding-left: 1.9rem !important;
        }

    #isData {
        color: #fff;
        opacity: 0;
    }

    .error {
        color: red;
    }
</style>
